import axios from 'axios';

export type FeedbackStatus = 'ACTIVE' | 'ALREADY_SUBMITTED' | 'EXPIRED' | string;

type NextStep = {
    label: string;
    type: 'LINK' | 'SMS' | string;
    action: string;
};

export type FeedbackNextSteps = {
    primary?: NextStep;
    secondary?: NextStep;
};

export type FeedbackInitResponse = {
    status: FeedbackStatus;
    message?: string;
    prospectName?: string;
    propertyName?: string;
    unitNumber?: string;
    tourDate?: string;
    isNoShow?: boolean;
    rating?: number | null;
    nextSteps?: FeedbackNextSteps;
    data?: {
        firstName?: string;
        lastName?: string;
    };
    type?: string;
};

export type FeedbackPartialPayload = {
    rating: number;
};

export type FeedbackSubmitPayload = {
    rating: number | null;
    reasons: string[];
    freeText: string;
};

export const getFeedbackForm = async (token: string): Promise<FeedbackInitResponse> => {
    const response = await axios.get(`/fb/${token}`);
    return response.data;
};

export const saveFeedbackPartial = async (token: string, payload: FeedbackPartialPayload) => {
    const response = await axios.post(`/fb/${token}/partial`, payload);
    return response.data;
};

export const submitFeedbackForm = async (token: string, payload: FeedbackSubmitPayload) => {
    const response = await axios.post(`/fb/${token}/submit`, payload);
    return response.data;
};
